exports.init = function() {
    window.postalVote = {};
}